import { Pipe, PipeTransform } from '@angular/core';
import { regex } from '../regex.constants';

@Pipe({ name: 'phone-format' })
/**
  * @function PhonePipe used to set the phone format
  * @param value it accepts a string
  * @returns string
  **/
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    // Handle null/undefined by converting to empty string
    if (value == null) {
      return '';
    }
    const strValue = value.toString();
    
    // If already formatted or matches phone pattern, return as-is
    if (strValue.match(regex.phonePatternWithChar)) {
      return strValue;
    }
    
    // For 11-digit numbers starting with 1, strip the leading 1
    let digitsOnly = strValue.replace(/\D/g, '');
    if (digitsOnly.length === 11 && digitsOnly.charAt(0) === '1') {
      digitsOnly = digitsOnly.substring(1);
    }
    
    // Format the 10-digit number
    return digitsOnly.replace(regex.phoneNumberPattern, '($1)$2-$3');
  }
}
